// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2KiuI","container":"styles_container__XS3ae","title":"styles_title__224iG","wrapper":"styles_wrapper__3pXG_","answer":"styles_answer__Ch74-"};